import React, { Component, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
//import PropTypes from 'prop-types';
import CommentEditForm from './forms/commentEditForm';
import ReplyForm from './forms/replyForm';
import ReplyOwnerMenu from './menus/replyOwnerMenu';

import { Avatar, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, IconButton, Typography, Divider, Chip } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ReplyIcon from '@mui/icons-material/Reply';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpAltTwoToneIcon from '@mui/icons-material/ThumbUpAltTwoTone';
import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector, useDispatch } from 'react-redux'

import ReplyReportMenu from './menus/replyReportMenu';
import ReplyEditForm from './forms/replyEditForm';
import produce from 'immer';
import { useImmer } from 'use-immer';

import moment from 'moment';

const PREFIX = 'Reply';

const classes = {
    root: `${PREFIX}-root`,
    avatarSection: `${PREFIX}-avatarSection`,
    textSection: `${PREFIX}-textSection`,
    menuSection: `${PREFIX}-menuSection`,
    clicked: `${PREFIX}-clicked`,
    icons: `${PREFIX}-icons`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
      width: '97%',
      display: 'flex',
      justifyContent: 'stretch',
    },

    [`& .${classes.avatarSection}`]: {
    //display: 'flex',
    //flexDirection: 'column',
    //cursor: 'pointer',
	},

    [`& .${classes.textSection}`]: {
		width: '70%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: '5px'
	},

    [`& .${classes.menuSection}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px'
	},

    [`& .${classes.clicked}`]: {
		backgroundColor: 'grey',
	},

    [`& .${classes.icons}`]: { 
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
	}
}));

const Reply = props => {

	
	const { updateContent, updateComment, contentId, commentId } = props;
	
	const [ isEditFormClicked, setIsEditFormClicked ] = useState(false);
	const [ isReplyFormClicked, setIsReplyFormClicked ] = useState(false);
	const [ isReplyDeleted, setIsReplyDeleted ] = useState(false);
	const [ mouseOver, setMouseOver ] = useState(false);
	const user = useSelector(state => state.user);
	const { root } = useSelector(state => state.api);
	const dispatch = useDispatch();

	const [ reply, updateReply ] = useImmer(props.reply);

	useEffect(() => {
		updateReply(draft => props.reply);
  }, [props.reply]);

	const isReplyOwner = user && reply.writer? reply.writer[0]._id === user._id : false;

	const handleMouseMove = () => {
    if(mouseOver) return;
    setMouseOver(true);
	}

	const handleReplyLike = () => {
    if(!user) return dispatch({ type: 'OPEN_SIGN_$' });
    //if(isReplyOwner) return;
		if(reply.userReaction.length === 0){
			fetch(`${root}/api/reaction/reply/${reply._id}/1/0`, { method: 'put', credentials: 'include' })
				.then(res => console.log('reaction update success'))
				.catch(err => console.log(err))
			updateContent(draft => {
					const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
				a.likeCount++; 
				a.userReaction = [{ type: 1 }];
			});
		} else {
		switch (reply.userReaction[0].type){ 
			case -1:
				fetch(`${root}/api/reaction/reply/${reply._id}/1/-1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
					updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
						a.likeCount++; 
						a.dislikeCount--;
						a.userReaction[0].type = 1;
					});
				break;
			case 0:
				fetch(`${root}/api/reaction/reply/${reply._id}/1/0`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
					a.likeCount++; 
					a.userReaction[0].type = 1;
				});
				break;
			case 1:
				fetch(`${root}/api/reaction/reply/${reply._id}/1/1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
					a.likeCount--; 
					a.userReaction[0].type = 0;
				});
				break;
		}
	}}

	const handleReplyDislike = () => {
    if(!user) return dispatch({ type: 'OPEN_SIGN_$' });
    //if(isReplyOwner) return;
		if(reply.userReaction.length === 0){
			fetch(`${root}/api/reaction/reply/${reply._id}/-1/0}`, { method: 'put', credentials: 'include' })
				.then(res => console.log('reaction update success'))
				.catch(err => console.log(err))
			updateContent(draft => {
					const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
				a.dislikeCount++; 
				a.userReaction = [{type: -1}];
			});
		} else {
		switch (reply.userReaction[0].type){ 
			case -1:
				fetch(`${root}/api/reaction/reply/${reply._id}/-1/-1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
					a.dislikeCount--;
					a.userReaction[0].type = 0;
				});
				break;
			case 0:
				fetch(`${root}/api/reaction/reply/${reply._id}/-1/0`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
					a.dislikeCount++; 
					a.userReaction[0].type = -1;
				});
				break;
			case 1:
				fetch(`${root}/api/reaction/reply/${reply._id}/-1/1`, { method: 'put', credentials: 'include' })
					.then(res => console.log('reaction update success'))
					.catch(err => console.log(err))
				updateContent(draft => {
						const a = draft.comments.find(element => element._id === commentId).replies.find(element => element._id === props.reply._id);
					a.likeCount--; 
					a.dislikeCount++; 
					a.userReaction[0].type = -1;
				});
				break;
		}
	}}
  const handleReplyFormClick = () => {
    if(!user)return dispatch({ type: 'OPEN_SIGN_$' });
    setIsReplyFormClicked(prev => !prev)
  }

	return (
        <Root>
					{
						!isEditFormClicked 
						?
							<div>
                <div className={classes.root} onMouseOver={()=>setMouseOver(true)} onMouseOut={()=>setMouseOver(false)} onMouseMove={handleMouseMove}>
                  <div className={classes.avatarSection} onClick={()=>dispatch({type:'OPEN_DRAWER', path: `/api/activities?person_id=${reply.writer[0]._id}`})}>
                  	<IconButton size="large">
	                    <Avatar alt="R" src={reply.writer[0].profileImageUrl}/>
                    </IconButton>
                  </div>
                  <div className={classes.textSection}>
                    <div style={{display:'flex', flexDirection: 'row'}}>
                      <p>{reply.writer[0].username || reply.writer[0].email + "  " + reply.createdAt.substr(0, 10)}</p>
                      <p style={{paddingLeft: '15px'}} >{moment(reply.createdAt).fromNow(true)}</p>
                    </div>
                      {/* reply.targetOwner? <Button style={{marginRight: '20px'}}>{reply.targetOwner.username}</Button> : null*/ }
                      <div align='left'>
                        {reply.persontags&&reply.persontags.map(persontag => <Chip style={{margin: '5px'}} label={'@'+persontag.username} />)} 
                      </div>
                      <Typography variant='body' align='left' style={{ wordWrap: "break-word" }}>
                        { reply.replyId? '@' + reply.targetOwner.username + "\xa0\xa0" + reply.text : reply.text }
                      </Typography>
                    <div className={classes.icons} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                      <IconButton
                          aria-label="like"
                          onClick={handleReplyLike}
                          size="small">
                        {
                          reply.userReaction.length > 0 && reply.userReaction[0].type === 1 
                          ? 
                            <FavoriteIcon fontSize='small' style={{color: 'red'}}/>
                          :
                            <FavoriteBorderIcon fontSize='small'/>
                        }
                      </IconButton>
                      <Typography variant="body2" component="span" color="text.secondary">
                        {reply.likeCount <= 0 ? 0 : reply.likeCount}
                      </Typography>
                      <IconButton aria-label="reply" onClick={handleReplyFormClick} size="small">
                        <ReplyIcon fontSize="small" />
                      </IconButton>
                      <Typography variant="body2" component="span" color="text.secondary">
                        {reply.replyCount ?? 0}
                      </Typography>
                    </div>

                  </div>
                <div className={classes.menuSection} style={{opacity: mouseOver? 1 : 0}}>
                  { 
                    isReplyOwner 
                    ? 
                      <ReplyOwnerMenu contentId={contentId} commentId={commentId} replyId={reply._id} updateContent={updateContent} updateComment={updateComment} setIsEditFormClicked={setIsEditFormClicked} setMouseOver={setMouseOver}/> 
                    : 
                      <ReplyReportMenu commentId={commentId} replyId={reply._id} updateContent={updateContent} handleOpen={props.handleOpen} setMouseOver={setMouseOver}/> 
                  }
                </div>
              </div>
								{ isReplyFormClicked ? <ReplyForm reply={reply} updateContent={updateContent} setIsReplyFormClicked={setIsReplyFormClicked} setIsReplyOpen={props.setIsReplyOpen} /> : null }
							</div>
						:
							<ReplyEditForm reply={reply} updateReply={updateReply} setIsEditFormClicked={setIsEditFormClicked}/>
					}
				</Root>
    );
}

export default Reply;

